export const CLEAR_VALIDATION_ERRORS = "CLEAR_VALIDATION_ERRORS";
export const SET_VALIDATION_ERRORS = "SET_VALIDATION_ERRORS";
export const DRAFT_PUBLISH_REQUEST_STARTED = "DRAFT_PUBLISH_REQUEST_STARTED";
export const DRAFT_PUBLISH_REQUEST_FAILED = "DRAFT_PUBLISH_REQUEST_FAILED";
export const DRAFT_PUBLISH_REQUEST_FAILED_WITH_VALIDATION_ERRORS =
  "DRAFT_PUBLISH_REQUEST_FAILED_WITH_VALIDATION_ERRORS";
